import { css } from 'styled-components'

export const imageStyle = css`
  position: relative;
  top: 30px;
  left: 160px;
`
